(function () {
  'use strict';

  angular.module('swif.patrimoine')
  .component('patrimoineOccupantsTableSig', {
      templateUrl: 'partials/patrimoine/patrimoine_occupant_table_sig.html',
        controller: PatrimoineOccupantsSigController
  })
  .controller('PatrimoineOccupantSigController', PatrimoineOccupantSigController);


  function PatrimoineOccupantsSigController($scope, swif, swifPatrimoineService) {
      'ngInject';
      console.log('init PatrimoineOccupantsSigController');
      $scope.referentiel = swifPatrimoineService.referentiel.data.referentiel;
      var contentType = $scope.referentiel.contentType;
      $scope.$watch('referentiel.currentItem', watchParent);
      $scope.preModal = preModal;
      $scope.preValidate = preValidate;
      $scope.callback = callback;
      $scope.isSIG = swif.settings.app.features.sigConnector;

      function updateCollection(ref_id) {
          var filter = {};
          swif.data.sortOn(filter, 'name');
          if (ref_id && contentType === 'patrimoine_site') {
              swif.data.addExtraFilter(filter, 'patrimoine', 'site_id', '=', ref_id);
          } else if (ref_id && contentType === 'patrimoine_equipment') {
              swif.data.addExtraFilter(filter, 'patrimoine', 'equipment_id', '=', ref_id);
          }
          swif.collections.createOrUpdate(
              'patrimoine_occupant_sig',
              'patrimoine_occupant_sig',
              filter
          ).then(function (collection) {
              $scope.occupants = collection;
          });
      }
      function watchParent(newV) {
          if (newV) {
              updateCollection(newV.id);
          }
      }
      function preModal(data) {
          $scope.occupants.preModal(data);
          var ct = $scope.referentiel.contentType;
          var mid = swif.settings.getContentType(ct).model;
          data.model._isSite = mid === 'openstc.site';
          data.model._isEqpt = mid === 'openstc.equipment';
          if (data.action.id === 'add') {
              data.model.res_model = mid;
              if (data.model._isSite) {
                  data.model.site_id = [
                      $scope.referentiel.currentItem.id,
                      $scope.referentiel.currentItem.name
                  ];
              } else if (data.model._isEqpt) {
                  data.model.equipment_id = [
                      $scope.referentiel.currentItem.id,
                      $scope.referentiel.currentItem.name
                  ];
              }
          }
      }
      function preValidate(data) {
          return $scope.occupants.preValidate(data);
      }
      function callback(error, data) {
          $scope.occupants.callback(error, data);
      }
  }


  function PatrimoineOccupantSigController($scope, swif, openbase) {
      'ngInject';
      console.log('init PatrimoineOccupantSigController');

      $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;

      $scope.choices = {states : [
        {id: 'public', name: 'Public'},
        {id: 'prive', name: 'Privé'},
      ]};
      $scope.STATES = {};
      _.forEach($scope.choices.states, function (item) {
          $scope.STATES[item.id] = item.name;
      });

      $scope.filters = {
        equipment: {fields: ['id', 'name', 'complete_name', 'equipment_reference']}
    };

      $scope.$watch('model.state', function (newV) {
          if (_.isString(newV)) {
              $scope.model.state = [newV, $scope.STATES[newV]];
          }
      });

  }


})();
